import React from "react"
import {
  TextField as MUITextField,
  TextFieldProps as MUITextFieldProps,
} from "@mui/material"
import { MUIMappedTextField } from "./mantine/TextField.mantine"

export type TextFieldProps =
  | ({ new: true } & MUITextFieldProps)
  | ({ new?: false } & MUITextFieldProps)

export const TextField = React.forwardRef<HTMLDivElement, TextFieldProps>(
  (props, ref) =>
    props.new ? (
      <MUIMappedTextField {...props} ref={ref} />
    ) : (
      <MUITextField {...props} ref={ref} />
    ),
)

TextField.displayName = "TextField"

export default TextField
